/* eslint-disable */
export default {
  meetingTitle: '{extensionName}の会議',
} as const;

// @key: @#@"meetingTitle"@#@ @source: @#@"{extensionName}'s Meeting"@#@
